<!--  -->
<template>
  <div>
      <section class="course-area">
        <div class="container course-wrapper">
            <div class="">
                <div class="row">
                    <div class="col-lg-9">
                        <div class="section-heading">
                            <div class="section__divider"></div>
                            <h2 class="section__title">课程学习</h2> 
                        </div><!-- end section-heading -->
                    </div><!-- end col-lg-12 -->
                    <div class="col-lg-3">
                        <div class="button-shared h-100 d-flex align-items-center justify-content-end">
                            <router-link class="theme-btn" to="/courviews">所有课程<i class="el-icon-arrow-right"></i></router-link>
                        </div><!-- end button-shared-->
                    </div><!-- end col-lg-3 -->
                </div><!-- end row -->
                <div class="fenl row">
                    <div class="col-lg-1">
                        <span class="fenl_text">分类</span>
                    </div><!-- end col-lg-12 -->
                    <div class="col-lg-11">
                        <div class="course-tab-wrap">
                            <ul class="course-tab-list nav nav-tabs" role="tablist" id="review">
                                <li role="presentation" v-for="(courcate,index) in courcates" :key="index">
                                    <a @click="chgcourcate(courcate.name)" role="tab" data-toggle="tab" :class="catesel==courcate?'active':''" aria-selected="true">
                                        {{courcate.name}}
                                    </a>
                                </li>
                            </ul>
                        </div><!-- end course-tab-wrap -->
                    </div><!-- end col-lg-12 -->
                </div><!-- end row -->
            </div><!-- end container -->
        </div><!-- end course-wrapper -->
       
        <div class="course-content-wrapper">
            <div class="container">
                 <div class="course-line"></div>
                <div class="row course-item-wrap">
                    <div class="col-lg-12">
                        <div class="tab-content">
                            <div role="tabpanel" class="tab-pane fade show active" id="tab1">
                                <div class="row course-block">
                                    <div class="col-lg-6" v-for="(course,index) in courses" :key="index">
                                        <div class="course-item" @click="$router.push(`/courview/info/${course._id}`)">
                                            <div class="course-img">
                                                <router-link :to="`/courview/info/${course._id}`" class="course__img"><img :src="`${global.remoteIp}/uploads/${course.picsrc}`" alt=""></router-link>
                                                <div class="course-tooltip">
                                                    <span v-if="course.spltip" class="tooltip-label">{{course.spltip}}</span>
                                                </div>
                                            </div><!-- end course-img -->
                                            <div class="course-content">
                                                <h3 class="course__title">
                                                    <router-link href="javascript::void(0)" :to="`/courview/info/${course._id}`">{{course.title}}</router-link>
                                                </h3>
                                                <div class="rating-wrap d-flex">
                                                    <span class="course__label-text">{{course.level}}</span>
                                                    <ul class="review-stars d-flex" v-if="course.stars">
                                                        <li><span :class="`la la-star${course.stars==0.5?'-half':course.stars>=1?'':'-o'}`"></span></li>
                                                        <li><span :class="`la la-star${course.stars==1.5?'-half':course.stars>=2?'':'-o'}`"></span></li>
                                                        <li><span :class="`la la-star${course.stars==2.5?'-half':course.stars>=3?'':'-o'}`"></span></li>
                                                        <li><span :class="`la la-star${course.stars==3.5?'-half':course.stars>=4?'':'-o'}`"></span></li>
                                                        <li><span :class="`la la-star${course.stars==4.5?'-half':course.stars>=5?'':'-o'}`"></span></li>
                                                    </ul>
                                                     <ul class="review-stars d-flex" v-else>
                                                        <li><span>暂无评分</span></li>
                                                    </ul>
                                                    <span class="star-rating-wrap" v-if="course.stars">
                                                        <span class="star__rating">{{parseFloat(course.stars).toFixed(1)}}</span>
                                                        <!-- <span class="star__count">({{course.star_count}})</span> -->
                                                    </span>
                                                </div><!-- end rating-wrap -->
                                                <div class="course-meta">
                                                    <ul class="course__list d-flex">
                                                        <li>
                                                            <span class="meta__date">
                                                                <i class="el-icon-video-play"></i> {{course.totalClass}}
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span class="meta__date">
                                                                <i class="el-icon-time"></i> {{course.totalTime}}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div><!-- end course-meta -->
                                                 <p class="course__author">
                                                    <a v-show="course.author">讲师：{{course.author}}</a>
                                                </p>
                                                <!-- <div class="course-price-wrap">
                                                    <div class="course-xstip" v-if="course.befprice">
                                                            <span class="xstip-label">限时特惠</span>
                                                      </div>
                                                     <span class="course__price"><span class="course__before-price" v-if="course.befprice">￥{{course.befprice}}</span>{{`${course.price=='0'?'免费':'￥'+course.price}`}} </span>
                                                      <div class="course-buytip" v-if="course.isBuy">
                                                            <span class="buytip-label">已购买</span>
                                                      </div>
                                                </div> -->
                                            </div><!-- end course-content -->
                                        </div><!-- end course-item -->
                                    </div><!-- end col-lg-4 -->
                                </div><!-- end course-block -->
                            </div><!-- end tab-pane -->
                        </div><!-- end tab-content -->
                    </div><!-- end col-lg-12 -->
                </div><!-- end row -->
            </div><!-- end container -->
        </div><!-- end course-content-wrapper -->
    </section>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data() {
    return {
      catesel: "",
      courcates: [
          "评分最高",
          "最受欢迎",
          "销量最高"
      ],
      courses: [],
      global,
    };
  },

  components: {},

  computed: {},

  mounted() {
    this.$axios
      .get("/api/bigCourseTypes?page=1&limit=12&sort=-createdAt")
      .then((res) => {
        if (res.data) {
          this.courcates = res.data.data;
        }
      });
    this.$axios
      .get("/api/courses/visitor?page=1&limit=6&sort=-istop,-createdAt")
      .then((res) => {
        if (res.data) {
          this.courses = res.data.data;
        }
      });
  },

  methods: {
    chgcourcate(cate) {
      this.catesel = cate;
      this.$axios
      .get("/api/courses/visitor?page=1&limit=6&spltip="+cate+"&sort=-istop,-createdAt")
      .then((res) => {
        if (res.data) {
          this.courses = res.data.data;
        }
      });
    },
  },
};
</script>
<style scoped>
.el-icon-video-play{
    font-weight: bold;
}
.el-icon-time{
    font-weight: bold;
}
.category-area{
	margin-top: 68px;
}
.course-area{
    background: #F8F8F8;
}
.course__label-text{
    margin-left: 23px;
}
</style>
